import i18n from "i18next";
import { initReactI18next } from "react-i18next";
import LanguageDetector from "i18next-browser-languagedetector";

i18n
  .use(initReactI18next)
  .use(LanguageDetector)
  .init({
    resources: {
      en: {
        translation: {
          "Auction": "Buy & Sell with Auction (BSA)",
          "login": "login",
          "Hire experts": "Hire experts",
          "Browse Jobs": "Browse posts",
          "Find BXP": "Find BXP",
          "Rent on urxprt": "Rent on urxprt",
          "Search": "Search",
          "Find Expert / Company": "Find Expert / Company",
          "Hire part time": "Hire part time",
          "Hire Full time": "Hire Full time",
          "Expert Registration": "Expert Registration",
          "Post Project": "Post Project",
          "Post Job": "Post Job",
          "Post Contest": "Post Contest",
          "Post BXP": "Post BXP",
          "Membership": "Membership",
          "Browse Jobs": "Browse posts",
          "Find projects": "Find projects",
          "Search Contest": "Search Contest",
          "Jobs you Applied": "Jobs you Applied",
          "Post a job": "Post a job",
          "Dashboard": "Dashboard",
          "My Orders": "My Orders",
          "Manage work": "Manage work",
          "Team": "Team",
          "Help & support": "Help & support",
          "View profile": "View Profile",
          "Find experts": "Find Experts",
          "Browse posts": "Browse posts",
          "Dashboard": "Dashboard",
          "Find OTS": "Find OTS",
          "Recruitment": "Full Time Job (FTJ)",
          "Find jobs": "Find jobs",
          "packaged Services": "packaged Services",
          "Buy & sell Products": "Buy & sell Products",
          "Product for Rental": "Product for Rental",
          "Auction": "Buy & Sell with Auction (BSA)",
          "Merger and Acquisition": "Merger and Acquisition",
          "Create a post": "Create a post",
          "Sign in": "Sign in",
          "Sign out": "Sign out",
          "Sign Up": "Sign Up",
          "Already have an account?": "Already have an account?",
          "Login": "Login",
          "Don’t have an account?": "Don’t have an account?",
          "OTS1":"One Time Services (OTS)",
          "BSM1":"Buy & Sell with Market (BSM)",
          "TAI1":"Turn Assets to Income (TAI)",
          "BSA1":"Buy & Sell with Auction (BSA)",
          "MAS1":"Mergers & Acquisitions Services (MAS)",
        },
      },
      ar: {
        translation: {
          "Already have an account?": "هل لديك حساب بالفعل؟",
          "Login": "تسجيل الدخول",
          "Don’t have an account?": "ليس لديك حساب؟",
          "Sign Up": "خدمات مغلفة",
          "Sign in": "خدمات مغلفة",
          "Sign out": "خدمات مغلفة",
          "Create a post": "خدمات مغلفة",
          "packaged Services": "خدمات مغلفة",
          "Buy & sell Products": "شراء وبيع المنتجات",
          "Product for Rental": "منتجات للإيجار",
          "Auction": "مزاد",
          "Merger and Acquisition": "الاندماج والاستحواذ",
          "Find jobs": "الاندماج والاستحواذ",
          "Recruitment": "التوظيف",
          "Find OTS": "ابحث عن OTS",
          "Browse posts": "تصفح المنشورات",
          "Find experts": "ابحث عن الخبراء",
          "Auction": "مزاد علني",
          "login": "جالدي كارو تسجيل الدخول",
          "Hire experts": "استئجار الخبراء",
          "Browse Jobs": "تصفح الوظائف",
          "Find BXP": "البحث عن BXP",
          "Rent on urxprt": "استئجار على urxprt",
          "Search": "بحث",
          "Find Expert / Company": "العثور على خبير / شركة",
          "Hire part time": "توظيف دوام جزئي",
          "Hire Full time": "توظيف دوام كامل",
          "Expert Registration": "تسجيل الخبير",
          "Post Project": "نشر مشروع",
          "Post Job": "نشر وظيفة",
          "Post Contest": "نشر مسابقة",
          "Post BXP": "نشر BXP",
          "Membership": "عضوية",
          "Browse Jobs": "تصفح الوظائف",
          "Find projects": "العثور على المشاريع",
          "Search Contest": "البحث عن مسابقة",
          "Jobs you Applied": "الوظائف التي تقدمت إليها",
          "Post a job": "انشر وظيفة",
          "Dashboard": "لوحة القيادة",
          "My Orders": "طلباتي",
          "Manage work": "إدارة العمل",
          "Team": "الفريق",
          "Help & support": "المساعدة والدعم",
          "Sign out": "تسجيل الخروج",
          "View profile": "عرض الصفحة الشخصية",
        },
      },
    },
    lng: "en",
    fallbackLng: "en",
    interpolation: {
      escapeValue: false,
    },

    detection: {
      order: ["path", "localStorage", "htmlTag", "cookie"],
      caches: ["localStorage", "cookie"],
    },
  });

export default i18n;
